export default class BalanceUpTableItem {
    userCode = "";
    userName = "";
    dutyHourTotal = "";
    balanceChangeBreakdown = "";
}
